import React, { useState, useEffect } from "react";
import { profileAvatar } from "../component/ImageList";
import baseURL from "../component/baseURL";
import stringsoflanguages from '../component/stringsoflanguages';
import { Link, useNavigate, useLocation } from "react-router-dom";
import PremiumSidebar from "./PremiumSidebar";

const MOBILE_PAGE_TITLE = "Consumer Apps Active";

export default function ConsumerAppActive() {
    const navigate = useNavigate();
    const location = useLocation();
    const isEmbeddedInPremiumHome = location.pathname.toLowerCase().includes("/premium-home");

    const [allConnections, setAllConnections] = useState([]);
    const [filteredConnections, setFilteredConnections] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [loading, setLoading] = useState(true);
    const [isMobile, setIsMobile] = useState(false);
    const [isMobilePageOpen, setIsMobilePageOpen] = useState(false);

    useEffect(() => {
        const userid = localStorage.getItem('user_id');
        fetchDetailsAPI(userid);
    }, []);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 767);
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    useEffect(() => {
        if (!isEmbeddedInPremiumHome && window.innerWidth <= 767) {
            setIsMobilePageOpen(true);
        }
    }, [isEmbeddedInPremiumHome]);

    useEffect(() => {
        if (isEmbeddedInPremiumHome) return;
        document.body.classList.add("premium-page");
        return () => {
            document.body.classList.remove("premium-page");
        };
    }, [isEmbeddedInPremiumHome]);

    function fetchDetailsAPI(userid) {
        console.log(userid)
        let formdata = new FormData();

        formdata.append("user_id", userid)
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")

        console.log(formdata)
        fetch(baseURL.URL + '/consumers/active_users', {
            method: 'POST',
            body: formdata

        }).then((response) => response.json())
            .then((responseJson) => {
                const memberList = responseJson?.response?.member_list;
                const result = Array.isArray(memberList) ? memberList : [];
                console.log(result)
                if (responseJson.server.result_code === 200) {
                    setAllConnections(result)
                    setFilteredConnections(result)
                }
                else {
                    setAllConnections([])
                    setFilteredConnections([])
                }
            })
            .catch((error) => {
                console.error(error);
                setAllConnections([])
                setFilteredConnections([])
            })
            .finally(() => {
                setLoading(false);
            });
    }

    function normalizeDisplayValue(value) {
        if (value == null) return "";
        const normalized = String(value).trim();
        if (!normalized) return "";
        const lowered = normalized.toLowerCase();
        if (lowered === "null" || lowered === "undefined") return "";
        return normalized;
    }

    function formatHeartCount(count) {
        const num = Number(count);
        if (Number.isNaN(num) || num < 0) return "0";
        if (num > 99) return "99+";
        return String(num);
    }

    function handleSearchByName(event) {
        const value = event.target.value;
        setSearchText(value);
        const normalizedSearch = value.trim().toLowerCase();

        if (!normalizedSearch) {
            setFilteredConnections(allConnections);
            return;
        }

        const filtered = allConnections.filter((member) => {
            const firstName = normalizeDisplayValue(member?.fname).toLowerCase();
            const lastName = normalizeDisplayValue(member?.lname).toLowerCase();
            const fullName = `${firstName} ${lastName}`.trim();
            return fullName.includes(normalizedSearch);
        });

        setFilteredConnections(filtered);
    }

    function handleMemberCardClick(member, fullName) {
        const consumerId = member?.consumer_id;
        const consumerName = fullName || "N/A";
        navigate("/premium-home/consumer-list", {
            state: {
                consumer_id: consumerId,
                consumer_name: consumerName,
                consumer_details: member,
                premiumSidebarActive: "Consumer Apps Active",
            },
        });
    }

    function handlePremiumSidebarItemClick(item) {
        window.dispatchEvent(
            new CustomEvent("premiumMembersView", {
                detail: { isViewing: item === "Premium Members" },
            })
        );
        navigate("/premium-home", { state: { initialActiveItem: item } });
    }

    function handleMobileBackEmbedded() {
        navigate("/premium-home");
    }

    function handleMobileBackStandalone() {
        setIsMobilePageOpen(false);
    }

    const mobilePageHeader = (onBack) => (
        <div className="mobile-page-header">
            <button type="button" className="mobile-back-btn" onClick={onBack}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <path
                        d="M15 18L9 12L15 6"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
                Back
            </button>
            <h2 className="mobile-page-title">{MOBILE_PAGE_TITLE}</h2>
        </div>
    );

    const memberListContent = (
        <>
            {/* Search and Filter Section */}
            <div className="search-filter-section">
                <div className="search-bar">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        className="search-icon"
                    >
                        <path
                            d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                            stroke="#E1730B"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M17.5 17.5L13.875 13.875"
                            stroke="#E1730B"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <input
                        type="text"
                        placeholder="Search by name / company"
                        className="search-input"
                        value={searchText}
                        onChange={handleSearchByName}
                    />
                </div>
                <button className="filter-btn">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M16.4062 4.69678C14.5256 4.69678 12.9441 6.04475 12.5793 7.82178H2.34375C1.91228 7.82178 1.5625 8.17156 1.5625 8.60303C1.5625 9.0345 1.91228 9.38428 2.34375 9.38428H12.5793C12.9441 11.1613 14.5256 12.5093 16.4062 12.5093C18.2869 12.5093 19.8684 11.1613 20.2332 9.38428H22.6562C23.0877 9.38428 23.4375 9.0345 23.4375 8.60303C23.4375 8.17156 23.0877 7.82178 22.6562 7.82178H20.2332C19.8684 6.04475 18.2869 4.69678 16.4062 4.69678ZM16.4062 6.25928C17.7099 6.25928 18.75 7.29938 18.75 8.60303C18.75 9.90668 17.7099 10.9468 16.4062 10.9468C15.1026 10.9468 14.0625 9.90668 14.0625 8.60303C14.0625 7.29938 15.1026 6.25928 16.4062 6.25928Z"
                            fill="white"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8.59375 12.5093C6.71313 12.5093 5.1316 13.8573 4.76685 15.6343H2.34375C1.91228 15.6343 1.5625 15.9841 1.5625 16.4155C1.5625 16.847 1.91228 17.1968 2.34375 17.1968H4.76685C5.1316 18.9738 6.71313 20.3218 8.59375 20.3218C10.4744 20.3218 12.0559 18.9738 12.4207 17.1968H22.6562C23.0877 17.1968 23.4375 16.847 23.4375 16.4155C23.4375 15.9841 23.0877 15.6343 22.6562 15.6343H12.4207C12.0559 13.8573 10.4744 12.5093 8.59375 12.5093ZM8.59375 14.0718C9.8974 14.0718 10.9375 15.1119 10.9375 16.4155C10.9375 17.7192 9.8974 18.7593 8.59375 18.7593C7.2901 18.7593 6.25 17.7192 6.25 16.4155C6.25 15.1119 7.2901 14.0718 8.59375 14.0718Z"
                            fill="white"
                        />
                    </svg>
                </button>
            </div>
            <span className='listing-count'>{stringsoflanguages.noofmembers}: {filteredConnections.length}</span>
            {/* Member Cards Grid */}
            <div className="member-cards-grid">
                {filteredConnections.map((member) => {
                    const firstName = normalizeDisplayValue(member?.fname);
                    const lastName = normalizeDisplayValue(member?.lname);
                    const fullName = `${firstName} ${lastName}`.trim() || "N/A";
                    const memberSince = normalizeDisplayValue(member?.last_login);
                    const title = normalizeDisplayValue(member?.email) || "N/A";
                    const city = normalizeDisplayValue(member?.city_name);
                    const country = normalizeDisplayValue(member?.country_name);
                    const location = [city, country].filter(Boolean).join(" - ") || "N/A";
                    const imageUrl =
                        normalizeDisplayValue(member?.picture) ||
                        profileAvatar;
                    const status = member?.active_status;
                    const heartCountLabel = formatHeartCount(member?.heart_count);
                    const isHeartCountMaxed = Number(member?.heart_count) > 99;

                    return (
                        <div
                            className={`member-card cursor-pointer ${status === '1' ? 'active-user' : 'inactive-user'}`}
                            key={member?.consumer_id || fullName}
                            onClick={() => handleMemberCardClick(member, fullName)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    handleMemberCardClick(member, fullName);
                                }
                            }}
                            role="button"
                            tabIndex={0}
                        >
                            <div className="member-info">
                                <p className="member-since">
                                    {memberSince ? `${stringsoflanguages.lastAppUse} ${memberSince}` : `${stringsoflanguages.lastAppUse} N/A`}
                                </p>
                                <h3 className="member-name">{fullName}</h3>
                                {/* <p className="member-role">{title}</p> */}
                                <p className="member-location">{location}</p>

                                <div
                                    className="contact-section flex items-center gap-2"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <Link to={`tel:${member?.phone}`} className="contact-btn">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#7323ff" strokeWidth="2">
                                            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                                        </svg>
                                    </Link>
                                    <Link to={`mailto:${member?.email}`} className="contact-btn">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#7323ff" strokeWidth="2">
                                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                            <polyline points="22,6 12,13 2,6" />
                                        </svg>
                                    </Link>
                                    <Link to={`sms:${member?.phone}`} className="contact-btn" aria-label="Message">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#7323ff" strokeWidth="2">
                                            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                                        </svg>
                                    </Link>
                                </div>
                            </div>
                            <div className="member-card-heart relative">
                                {member?.active_status == 1 ? (
                                    <span
                                        className="member-heart-with-count"
                                        aria-label={`${heartCountLabel} favorites`}
                                    >
                                        <i className="fa-solid fa-heart text-red-500" aria-hidden="true" />
                                        <span className={`member-heart-count${isHeartCountMaxed ? " member-heart-count--plus" : ""}`}>
                                            {heartCountLabel}
                                        </span>
                                    </span>
                                ) : null}
                                <div className="member-image">
                                    <img src={imageUrl} alt={fullName} />
                                </div>
                            </div>

                        </div>
                    );
                })}
            </div>
        </>
    );

    const pageLoader = (
        <div className="content-right page-loader-wrapper">
            <div className="react-js-loader">
                <div className="react-js-loader-spinner"></div>
                <p className="react-js-loader-text">{stringsoflanguages.loading}</p>
            </div>
        </div>
    );

    if (loading) {
        if (isEmbeddedInPremiumHome) {
            return (
                <>
                    {isMobile && mobilePageHeader(handleMobileBackEmbedded)}
                    {pageLoader}
                </>
            );
        }

        return (
            <section className="home">
                <div className="container">
                    <div className="content-holder">
                        <PremiumSidebar
                            activeItem={MOBILE_PAGE_TITLE}
                            setActiveItem={handlePremiumSidebarItemClick}
                        />
                        <div
                            className={`content-right-wrapper ${isMobilePageOpen ? "mobile-page-open" : ""}`}
                        >
                            {isMobile && isMobilePageOpen && mobilePageHeader(handleMobileBackStandalone)}
                            {pageLoader}
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (isEmbeddedInPremiumHome) {
        return (
            <>
                {isMobile && mobilePageHeader(handleMobileBackEmbedded)}
                <div className="content-right">{memberListContent}</div>
            </>
        );
    }

    return (
        <section className="home">
            <div className="container">
                <div className="content-holder">
                    <PremiumSidebar
                        activeItem={MOBILE_PAGE_TITLE}
                        setActiveItem={handlePremiumSidebarItemClick}
                    />
                    <div
                        className={`content-right-wrapper ${isMobilePageOpen ? "mobile-page-open" : ""}`}
                    >
                        {isMobile && isMobilePageOpen && mobilePageHeader(handleMobileBackStandalone)}
                        <div className="content-right">{memberListContent}</div>
                    </div>
                </div>
            </div>
        </section>
    );
}